var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaoPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_1636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 8.33334C17.4995 14.1667 9.99951 19.1667 9.99951 19.1667C9.99951 19.1667 2.49951 14.1667 2.49951 8.33334C2.49951 6.34422 3.28969 4.43657 4.69621 3.03004C6.10273 1.62352 8.01039 0.833344 9.99951 0.833344C11.9886 0.833344 13.8963 1.62352 15.3028 3.03004C16.7093 4.43657 17.4995 6.34422 17.4995 8.33334Z",
    stroke: "#5C5CAB",
    strokeWidth: 1.8595,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 10.8333C11.3802 10.8333 12.4995 9.71406 12.4995 8.33334C12.4995 6.95263 11.3802 5.83334 9.99951 5.83334C8.6188 5.83334 7.49951 6.95263 7.49951 8.33334C7.49951 9.71406 8.6188 10.8333 9.99951 10.8333Z",
    stroke: "#5C5CAB",
    strokeWidth: 1.8595,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaoPin);
export default __webpack_public_path__ + "static/media/mao-pin.e9731cf3704906e9faed170a5447756a.svg";
export { ForwardRef as ReactComponent };